export const analyticsActionTypes = {
  ANALYTICS_LOADING: "ANALYTICS_LOADING",
  ANALYTICS_SUCCESS: "ANALYTICS_SUCCESS",
  ANALYTICS_ERROR: "ANALYTICS_ERROR",
  ANALYTICS_RESET: "ANALYTICS_RESET",
};
